import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';

import '../style/about.css'

function About(){
    const { t } = useTranslation();

    return(
        <section id='about' className="block about-block">
            <Container fluid>
                <div className='title-holder'>
                    <h2>{t('about.title')}</h2>
                    {/* <div className='subtitle'>Notre gamme variée de services</div> */}
                </div>
                <div className='about-content'>
                    <Row>
                        <Col sm={6}>
                            <div className='about-text'>
                                {t('about.mainText')}
                            </div>
                        </Col>
                        <Col sm={6} className='expertise-col'>
                            <div className='expertise-content'>
                                {t('about.expertiseTitle')}
                                <ul>
                                    <li>{t('about.expertiseList.item1')}</li>
                                    <li>{t('about.expertiseList.item2')}</li>
                                    <li>{t('about.expertiseList.item3')}</li>
                                    <li>{t('about.expertiseList.item4')}</li>
                                    <li>{t('about.expertiseList.item5')}</li>
                                    <li>{t('about.expertiseList.item6')}</li>
                                    <li>{t('about.expertiseList.item7')}</li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
    );
}

export default About;